// extracted by mini-css-extract-plugin
export default {"innerWrapper":"oB-z","tooltipWrapper":"pB-z","icon":"qB-z","tooltip":"rB-z","content":"sB-z"};